import WidgetTextConcisePresentation from 'components/WidgetTextConcise/WidgetTextConcisePresentation'

export default {
  Presentation: WidgetTextConcisePresentation,
}
